import { css, injectGlobal } from 'styled-components';

import 'typeface-nunito-sans';
import 'typeface-montserrat';

export const theme = {
  white: '#fff',
  black: '#001b38',
  grey: '#9b9b9b',
  text: '#231f20',
  lightBlue: '#f6f8fb',
  darkBlue: '#334781',
  mediumBlue: '#003a69',
  primaryBlue: '#0057b8',
  space: '1.5rem',
  halfSpace: '.75rem',
  quarterSpace: '.375rem',
  eighthSpace: '.1875rem',
  doubleSpace: '3rem',
  fourxSpace: '6rem',
  radius: '3px',
  headingFont: 'Montserrat, Helvetica, Arial, sans-serif',
  bodyFont: 'Nunito Sans, Helvetica, Arial, sans-serif'
};

// Global styles tied to theme variables.
injectGlobal`
  html {
    font-family: ${theme.bodyFont};
  }

  body {
    background-color: ${theme.white};
    color: ${theme.text};
  }

  h1 {
    color: ${theme.darkBlue};
    font-family: ${theme.headingFont};
    margin-bottom: ${theme.space};
  }

  a {
    color: ${theme.primaryBlue};
  }
`;

// Simple helper function, takes in any number of props mapping to properties within the theme
// object and returns the value.
export const getTheme = (...props) => ({ theme }) =>
  props.reduce((t, p) => t[p], theme);

const breakpoints = {
  small: 600,
  medium: 960,
  lg: 1280
};

// MEDIA QUERIES
export const media = {
  small: (...args) => css`
    @media (min-width: ${breakpoints.small}px) {
      ${css(...args)};
    }
  `,
  medium: (...args) => css`
    @media (min-width: ${breakpoints.medium}px) {
      ${css(...args)};
    }
  `,
  lg: (...args) => css`
    @media (min-width: ${breakpoints.lg}px) {
      ${css(...args)};
    }
  `
};



// WEBPACK FOOTER //
// ./src/util/theme.js